var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        attrs: {
          type: "tabcard",
          align: "left",
          inlineLabel: true,
          dense: true,
          tabItems: _vm.child.tabItems,
          height: _vm.tabHeight,
        },
        on: {
          "update:height": function ($event) {
            _vm.tabHeight = $event
          },
          tabClick: _vm.tabClick,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  key: tab.key,
                  tag: "component",
                  attrs: {
                    patrol: _vm.patrol,
                    resultItems: _vm.resultItems,
                    colorItemse: _vm.colorItems,
                    place: tab.place,
                    eventScroll: _vm.eventScroll,
                    currentTab: _vm.currentTab,
                    contentHeight: _vm.contentHeight,
                  },
                  on: {
                    "update:resultItems": function ($event) {
                      _vm.resultItems = $event
                    },
                    "update:result-items": function ($event) {
                      _vm.resultItems = $event
                    },
                    "update:colorItemse": function ($event) {
                      _vm.colorItems = $event
                    },
                    "update:color-itemse": function ($event) {
                      _vm.colorItems = $event
                    },
                    "update:place": function ($event) {
                      return _vm.$set(tab, "place", $event)
                    },
                    "update:eventScroll": function ($event) {
                      _vm.eventScroll = $event
                    },
                    "update:event-scroll": function ($event) {
                      _vm.eventScroll = $event
                    },
                    "update:currentTab": function ($event) {
                      _vm.currentTab = $event
                    },
                    "update:current-tab": function ($event) {
                      _vm.currentTab = $event
                    },
                    tranStep: _vm.tranStep,
                    research: _vm.research,
                    closePopup: _vm.closePopup,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.child.tab,
          callback: function ($$v) {
            _vm.$set(_vm.child, "tab", $$v)
          },
          expression: "child.tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }